/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CustomerUpdate = {
    properties: {
        firstName: {
            type: 'string',
            isNullable: true,
        },
        lastName: {
            type: 'string',
            isNullable: true,
        },
        fullName: {
            type: 'string',
            isNullable: true,
        },
        email: {
            type: 'string',
            isNullable: true,
        },
        homePhone: {
            type: 'string',
            isNullable: true,
        },
        workPhone: {
            type: 'string',
            isNullable: true,
        },
        cellPhone: {
            type: 'string',
            isNullable: true,
        },
        street: {
            type: 'string',
            isNullable: true,
        },
        street2: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isNullable: true,
        },
        state: {
            type: 'string',
            isNullable: true,
            maxLength: 2,
            minLength: 2,
        },
        zip: {
            type: 'string',
            isNullable: true,
            maxLength: 10,
            minLength: 5,
        },
        zip4: {
            type: 'string',
            isNullable: true,
            maxLength: 4,
        },
        changeAll: {
            type: 'boolean',
            isNullable: true,
        },
    },
};